import * as Yup from 'yup'

export const enviarSchema = Yup.object().shape({
  telefone: Yup.string()
    .trim()
    .matches(/^\(\d{2}\) (\d )?\d{4}-\d{4}$/, 'Formato deve ser (00) 0000-0000 ou (00) 0 0000-0000')
    .when('email', {
      is: (email: string) => !email || email.trim() === '',
      then: (schema) => schema.required('Informe telefone ou e-mail'),
      otherwise: (schema) => schema.notRequired(),
    }),
  email: Yup.string().email('E-mail inválido').notRequired(),
})
